/**
 * Helpers de navegação do shell autenticado.
 * Fase 2: cada painel principal tem uma URL real, reaproveitando o shell
 * do `Welcome` (main_display). O Redux `app_status` continua alimentando o
 * switch interno e o destaque do sidebar, agora sincronizado com a rota.
 */
import { appStatus } from "../store/modules/app_status/actions";

export const WELCOME_PATH = "/welcome";
export const GUARDIAN_PANEL = "Guardião";

/** Status do painel → rota real (URL deep-linkável). */
export const PANEL_ROUTES = {
  Dashboard: "/dashboard",
  "Meus Alertas": "/my-alerts",
  Usuários: "/users",
  Projetos: "/projects",
  Contas: "/accounts",
  "Meu Perfil": "/profile",
  Configurações: "/settings",
  [GUARDIAN_PANEL]: "/guardian",
};

/** Rota real → status do painel. */
export const ROUTE_PANELS = Object.entries(PANEL_ROUTES).reduce(
  (acc, [status, path]) => {
    acc[path] = status;
    return acc;
  },
  {}
);

/** Prefixos/rotas do fluxo Guardian. */
export const GUARDIAN_ROUTE_PREFIXES = [
  "/guardian",
  "/areas",
  "/archived_areas",
  "/create_area",
  "/area_details",
  "/edit_area",
  "/view_alerts",
  "/view_alert_request",
  "/new_alert",
  "/alert-details",
  "/alert-register-action",
  "/alerts",
  "/firms",
  "/user_request",
  "/add_user_request",
  "/guardian/invite-welcome",

];

export function isGuardianRoute(pathname = "") {
  return GUARDIAN_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

/**
 * Navega para um painel principal.
 * - Se o status tem rota real (Dashboard, Guardião, etc.), usa a URL própria.
 * - Sub-status legados (cad_new_user, edit_user…) caem no shell /welcome.
 */
export function goToPanel(dispatch, navigate, panelStatus, navOptions = {}) {
  if (typeof dispatch === "function" && panelStatus) {
    dispatch(appStatus(panelStatus));
  }

  const route = PANEL_ROUTES[panelStatus];
  if (route) {
    navigate(route, navOptions);
  } else {
    navigate(WELCOME_PATH, navOptions);
  }
}

/** Compat: mantém a assinatura antiga usada por telas legadas. */
export function goToWelcomePanel(dispatch, navigate, panelStatus, navOptions = {}) {
  goToPanel(dispatch, navigate, panelStatus, navOptions);
}

/**
 * Hub Guardian — usar nos botões "Voltar" do fluxo Guardian.
 */
export function goToGuardianHub(dispatch, navigate, navOptions = {}) {
  goToPanel(dispatch, navigate, GUARDIAN_PANEL, {
    ...navOptions,
    state: {
      ...(navOptions.state || {}),
      activeTab: navOptions.state?.activeTab || "panel",
    },
  });
}

/** Abre o formulário de novo alerta dentro do hub (abas permanecem). */
export function goToGuardianNewAlert(dispatch, navigate, state = {}, navOptions = {}) {
  goToGuardianHub(dispatch, navigate, {
    ...navOptions,
    state: {
      ...state,
      ...(navOptions.state || {}),
      activeTab: "new_alert",
    },
  });
}

/**
 * Abre detalhes do alerta mantendo o painel Guardião (sem status fantasma).
 */
export function openAlertDetails(dispatch, navigate, state = {}, navOptions = {}) {
  if (typeof dispatch === "function") {
    dispatch(appStatus(GUARDIAN_PANEL));
  }
  navigate("/alert-details", { ...navOptions, state });
}
